import type { Course } from '@/data/models'
import coursesList from '@/data/coursesList'

export function normalizeStoredCourses(storedCourses: Course[] = []): Course[] {
  const storedCoursesById = new Map(storedCourses.map((course) => [course.id, course]))
  const normalizedCatalogCourses = coursesList.map((catalogCourse) => {
    const storedCourse = storedCoursesById.get(catalogCourse.id)
    if (!storedCourse) {
      return catalogCourse
    }

    return {
      ...catalogCourse,
      included: storedCourse.included,
      grade: storedCourse.grade,
      exam: storedCourse.exam,
      exam2: storedCourse.exam2,
      improved: storedCourse.improved,
      improved2: storedCourse.improved2,
      hadExam: storedCourse.hadExam,
      numExams: storedCourse.numExams,
      timestampAdded: storedCourse.timestampAdded,
      visible: storedCourse.visible,
    }
  })

  const customCourses = storedCourses.filter(
    (storedCourse) => !coursesList.some((catalogCourse) => catalogCourse.id === storedCourse.id)
  )

  return [...normalizedCatalogCourses, ...customCourses]
}
